<template>
  <div>
    <input-with-validation ref="input" :disabled="readOnly" :vid="randomVid" :field-label="$attrs.label" :rules="rules" :placeholder="placeholder" b-name="input" v-model="model"></input-with-validation>
  </div>
</template>

<script>
import InputWithValidation from "@/components/validation/InputWithValidation";
import ElementRendererMixin from "@/components/form_builder/ElementRendererMixin";
export default {
  name: "TextElementRenderer",
  mixins: [ElementRendererMixin],
  components: {InputWithValidation},
}
</script>
<style scoped>

</style>
